import AbsenceUserSubordinates from 'features/absence/absenceUserSubordination';
import { useTitle } from '../helpers';

/**
 * @page Absence subordinates page
 */

const AbsenceSubordinationPage = () => {
  useTitle('Информация о подчинённом');

  return (
    <div>
      <h3>Страница информации о подчинённом</h3>
      <AbsenceUserSubordinates />
    </div>
  );
};

export default AbsenceSubordinationPage;
